import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import RadioQuestion from './RadioQuestion';

export default function Step1Location({ data, onUpdate, onCountryChange, errors }) {
  const { t } = useTranslation();

  return (
    <div data-testid="quiz-step-1">
      <h2 className="text-2xl font-medium text-primary mb-6" style={{ fontFamily: 'Outfit' }}>{t('quiz.step1Title')}</h2>
      <div className="space-y-6">
        <div>
          <Label htmlFor="country" className="mb-2 block">{t('quiz.country')} *</Label>
          <Select value={data.country} onValueChange={onCountryChange}>
            <SelectTrigger data-testid="country-select" className={errors?.country ? 'border-destructive' : ''}>
              <SelectValue placeholder={t('quiz.selectCountry')} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="NL">Nederland / Netherlands</SelectItem>
              <SelectItem value="BE">België / Belgium</SelectItem>
              <SelectItem value="DE">Deutschland / Germany</SelectItem>
              <SelectItem value="FR">France</SelectItem>
            </SelectContent>
          </Select>
          {errors?.country && <p className="text-xs text-destructive mt-1">{errors.country}</p>}
        </div>

        {data.country === 'BE' && (
          <div>
            <Label className="mb-2 block">{t('quiz.region')}</Label>
            <Select value={data.region} onValueChange={(val) => onUpdate({ region: val })}>
              <SelectTrigger data-testid="be-region-select">
                <SelectValue placeholder={t('quiz.selectRegion')} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Flanders">Vlaanderen / Flanders</SelectItem>
                <SelectItem value="Wallonia">Wallonie / Wallonia</SelectItem>
                <SelectItem value="Brussels">Brussel / Bruxelles</SelectItem>
              </SelectContent>
            </Select>
          </div>
        )}

        {data.country && data.country !== 'BE' && (
          <div>
            <Label htmlFor="region" className="mb-2 block">{t('quiz.region')}</Label>
            <Input id="region" placeholder={t('quiz.regionPlaceholder')} value={data.region} onChange={(e) => onUpdate({ region: e.target.value })} data-testid="region-input" />
          </div>
        )}

        <div>
          <Label htmlFor="postcode" className="mb-2 block">{t('quiz.postcode')}</Label>
          <Input id="postcode" placeholder="e.g., 1012 AB" value={data.postcode} onChange={(e) => onUpdate({ postcode: e.target.value })} data-testid="postcode-input" />
        </div>

        <RadioQuestion
          label={`${t('quiz.homeType')} *`}
          value={data.home_type}
          options={[
            { value: 'Apartment', label: t('quiz.homeTypes.apartment') },
            { value: 'Terraced House', label: t('quiz.homeTypes.terraced') },
            { value: 'Semi-Detached House', label: t('quiz.homeTypes.semiDetached') },
            { value: 'Detached House', label: t('quiz.homeTypes.detached') },
            { value: 'Monument / Protected', label: t('quiz.homeTypes.monument') },
          ]}
          onChange={(val) => onUpdate({ home_type: val })}
          testIdPrefix="home-type"
          error={errors?.home_type}
        />

        <RadioQuestion
          label={`${t('quiz.ownership')} *`}
          value={data.ownership}
          options={[
            { value: 'Owner-occupied', label: t('quiz.ownershipTypes.owner') },
            { value: 'Rental', label: t('quiz.ownershipTypes.rental') },
          ]}
          onChange={(val) => onUpdate({ ownership: val })}
          testIdPrefix="ownership"
          error={errors?.ownership}
        />
      </div>
    </div>
  );
}
